class CurrencyConversionRateController extends BaseController
	@register angular.module 'App.Module.Controller'
	@inject 'conversionRates'

	initialize: ->
		@conversionRates = @removeSameCurrencyRates(@conversionRates)
		@conversionRates = @sortByCurrency(@conversionRates)
		@conversionRates = @indexByFromCurrency(@conversionRates)

	removeSameCurrencyRates: (rates) ->
		return _.reject rates, (rate) ->
			rate.currencyIso == rate.toCurrencyIso

	sortByCurrency: (rates) ->
		return _.chain(rates)
			.sortBy('toCurrencyIso')
			.sortBy('currencyIso')
			.value()

	indexByFromCurrency: (rates) ->
		return _.groupBy(rates, 'currencyIso')
